export default "__VITE_ASSET__BB03_Vao__"